(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Stately-stately-concurrent-collections'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Stately-stately-concurrent-collections'.");
    }
    globalThis['Stately-stately-concurrent-collections'] = factory(typeof globalThis['Stately-stately-concurrent-collections'] === 'undefined' ? {} : globalThis['Stately-stately-concurrent-collections'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var VOID = kotlin_kotlin.$_$.d;
  var protoOf = kotlin_kotlin.$_$.eh;
  var MutableCollection = kotlin_kotlin.$_$.h7;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var KtMutableSet = kotlin_kotlin.$_$.l7;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ConcurrentMutableCollection, 'ConcurrentMutableCollection', VOID, VOID, [MutableCollection]);
  initMetadataForClass(ConcurrentMutableIterator, 'ConcurrentMutableIterator');
  initMetadataForClass(ConcurrentMutableMap, 'ConcurrentMutableMap', ConcurrentMutableMap_init_$Create$, VOID, [KtMutableMap]);
  initMetadataForClass(ConcurrentMutableSet, 'ConcurrentMutableSet', ConcurrentMutableSet_init_$Create$, ConcurrentMutableCollection, [KtMutableSet]);
  //endregion
  function ConcurrentMutableCollection$_get_size_$lambda_dssf9y(this$0) {
    return function () {
      return this$0.ts1_1.n1();
    };
  }
  function ConcurrentMutableCollection$contains$lambda(this$0, $element) {
    return function () {
      return this$0.ts1_1.m1($element);
    };
  }
  function ConcurrentMutableCollection$containsAll$lambda(this$0, $elements) {
    return function () {
      return this$0.ts1_1.r2($elements);
    };
  }
  function ConcurrentMutableCollection$isEmpty$lambda(this$0) {
    return function () {
      return this$0.ts1_1.r();
    };
  }
  function ConcurrentMutableCollection$add$lambda(this$0, $element) {
    return function () {
      return this$0.ts1_1.j1($element);
    };
  }
  function ConcurrentMutableCollection$addAll$lambda(this$0, $elements) {
    return function () {
      return this$0.ts1_1.o1($elements);
    };
  }
  function ConcurrentMutableCollection$clear$lambda(this$0) {
    return function () {
      this$0.ts1_1.c3();
      return Unit_instance;
    };
  }
  function ConcurrentMutableCollection$iterator$lambda(this$0) {
    return function () {
      return new ConcurrentMutableIterator(this$0.us1_1, this$0.ts1_1.t());
    };
  }
  function ConcurrentMutableCollection$remove$lambda(this$0, $element) {
    return function () {
      return this$0.ts1_1.d3($element);
    };
  }
  function ConcurrentMutableCollection(rootArg, del) {
    rootArg = rootArg === VOID ? null : rootArg;
    this.ts1_1 = del;
    var tmp = this;
    tmp.us1_1 = rootArg == null ? this : rootArg;
  }
  protoOf(ConcurrentMutableCollection).n1 = function () {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$_get_size_$lambda_dssf9y(this)();
  };
  protoOf(ConcurrentMutableCollection).m1 = function (element) {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$contains$lambda(this, element)();
  };
  protoOf(ConcurrentMutableCollection).r2 = function (elements) {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$containsAll$lambda(this, elements)();
  };
  protoOf(ConcurrentMutableCollection).r = function () {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$isEmpty$lambda(this)();
  };
  protoOf(ConcurrentMutableCollection).j1 = function (element) {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$add$lambda(this, element)();
  };
  protoOf(ConcurrentMutableCollection).o1 = function (elements) {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$addAll$lambda(this, elements)();
  };
  protoOf(ConcurrentMutableCollection).c3 = function () {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    ConcurrentMutableCollection$clear$lambda(this)();
  };
  protoOf(ConcurrentMutableCollection).t = function () {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$iterator$lambda(this)();
  };
  protoOf(ConcurrentMutableCollection).d3 = function (element) {
    this.us1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableCollection$remove$lambda(this, element)();
  };
  function ConcurrentMutableIterator$hasNext$lambda(this$0) {
    return function () {
      return this$0.ws1_1.u();
    };
  }
  function ConcurrentMutableIterator$next$lambda(this$0) {
    return function () {
      return this$0.ws1_1.v();
    };
  }
  function ConcurrentMutableIterator$remove$lambda(this$0) {
    return function () {
      this$0.ws1_1.l4();
      return Unit_instance;
    };
  }
  function ConcurrentMutableIterator(root, del) {
    this.vs1_1 = root;
    this.ws1_1 = del;
  }
  protoOf(ConcurrentMutableIterator).u = function () {
    this.vs1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableIterator$hasNext$lambda(this)();
  };
  protoOf(ConcurrentMutableIterator).v = function () {
    this.vs1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableIterator$next$lambda(this)();
  };
  protoOf(ConcurrentMutableIterator).l4 = function () {
    this.vs1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    ConcurrentMutableIterator$remove$lambda(this)();
  };
  function ConcurrentMutableMap_init_$Init$($this) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var tmp$ret$0 = LinkedHashMap_init_$Create$();
    ConcurrentMutableMap.call($this, null, tmp$ret$0);
    return $this;
  }
  function ConcurrentMutableMap_init_$Create$() {
    return ConcurrentMutableMap_init_$Init$(objectCreate(protoOf(ConcurrentMutableMap)));
  }
  function ConcurrentMutableMap$_get_size_$lambda_nuyc4q(this$0) {
    return function () {
      return this$0.xs1_1.n1();
    };
  }
  function ConcurrentMutableMap$_get_entries_$lambda_dp7xtt(this$0) {
    return function () {
      return new ConcurrentMutableSet(this$0, this$0.xs1_1.s1());
    };
  }
  function ConcurrentMutableMap$_get_keys_$lambda_5gjoyr(this$0) {
    return function () {
      return new ConcurrentMutableSet(this$0, this$0.xs1_1.x2());
    };
  }
  function ConcurrentMutableMap$_get_values_$lambda_tyvlyt(this$0) {
    return function () {
      return new ConcurrentMutableCollection(this$0, this$0.xs1_1.y2());
    };
  }
  function ConcurrentMutableMap$containsKey$lambda(this$0, $key) {
    return function () {
      return this$0.xs1_1.u2($key);
    };
  }
  function ConcurrentMutableMap$containsValue$lambda(this$0, $value) {
    return function () {
      return this$0.xs1_1.v2($value);
    };
  }
  function ConcurrentMutableMap$get$lambda(this$0, $key) {
    return function () {
      return this$0.xs1_1.w2($key);
    };
  }
  function ConcurrentMutableMap$isEmpty$lambda(this$0) {
    return function () {
      return this$0.xs1_1.r();
    };
  }
  function ConcurrentMutableMap$clear$lambda(this$0) {
    return function () {
      this$0.xs1_1.c3();
      return Unit_instance;
    };
  }
  function ConcurrentMutableMap$put$lambda(this$0, $key, $value) {
    return function () {
      return this$0.xs1_1.z2($key, $value);
    };
  }
  function ConcurrentMutableMap$putAll$lambda(this$0, $from) {
    return function () {
      this$0.xs1_1.b3($from);
      return Unit_instance;
    };
  }
  function ConcurrentMutableMap$remove$lambda(this$0, $key) {
    return function () {
      return this$0.xs1_1.a3($key);
    };
  }
  function ConcurrentMutableMap(rootArg, del) {
    rootArg = rootArg === VOID ? null : rootArg;
    this.xs1_1 = del;
    var tmp = this;
    tmp.ys1_1 = rootArg == null ? this : rootArg;
  }
  protoOf(ConcurrentMutableMap).n1 = function () {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$_get_size_$lambda_nuyc4q(this)();
  };
  protoOf(ConcurrentMutableMap).s1 = function () {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$_get_entries_$lambda_dp7xtt(this)();
  };
  protoOf(ConcurrentMutableMap).x2 = function () {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$_get_keys_$lambda_5gjoyr(this)();
  };
  protoOf(ConcurrentMutableMap).y2 = function () {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$_get_values_$lambda_tyvlyt(this)();
  };
  protoOf(ConcurrentMutableMap).u2 = function (key) {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$containsKey$lambda(this, key)();
  };
  protoOf(ConcurrentMutableMap).v2 = function (value) {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$containsValue$lambda(this, value)();
  };
  protoOf(ConcurrentMutableMap).w2 = function (key) {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$get$lambda(this, key)();
  };
  protoOf(ConcurrentMutableMap).r = function () {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$isEmpty$lambda(this)();
  };
  protoOf(ConcurrentMutableMap).c3 = function () {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    ConcurrentMutableMap$clear$lambda(this)();
  };
  protoOf(ConcurrentMutableMap).z2 = function (key, value) {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$put$lambda(this, key, value)();
  };
  protoOf(ConcurrentMutableMap).b3 = function (from) {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    ConcurrentMutableMap$putAll$lambda(this, from)();
  };
  protoOf(ConcurrentMutableMap).a3 = function (key) {
    this.ys1_1;
    // Inline function 'co.touchlab.stately.concurrency.synchronize' call
    return ConcurrentMutableMap$remove$lambda(this, key)();
  };
  function ConcurrentMutableSet_init_$Init$($this) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var tmp$ret$0 = LinkedHashSet_init_$Create$();
    ConcurrentMutableSet.call($this, null, tmp$ret$0);
    return $this;
  }
  function ConcurrentMutableSet_init_$Create$() {
    return ConcurrentMutableSet_init_$Init$(objectCreate(protoOf(ConcurrentMutableSet)));
  }
  function ConcurrentMutableSet(rootArg, del) {
    ConcurrentMutableCollection.call(this, rootArg, del);
    this.bs2_1 = del;
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = ConcurrentMutableMap_init_$Create$;
  _.$_$.b = ConcurrentMutableSet_init_$Create$;
  //endregion
  return _;
}));

//# sourceMappingURL=Stately-stately-concurrent-collections.js.map
